export default __webpack_public_path__ + "static/media/loader.63845ea4.svg";